import { Options } from 'amqplib';

export enum QueueNames {
  CANCELLATION_TRADE = 'cancellation_trade',
  CANCEL_ORDER = 'cancelOrder',
  MAINTENANCE = 'maintenance',
  SYSTEM = 'system',
  NEW_ORDER = 'newOrder',
  PROCESS_WALLET_TRANSACTION = 'wallet_transaction',
  LAST_LOOK_TRADE = 'last_look_trade',
  SEND_TRADE_TO_SETTLE = 'send_trade_to_settle',
  TRADE_FIRE = 'trade_fire',
  TRADE_CONFIRMED = 'trade_confirmed',
  ORDER_OPERATION = 'order_operation',
  ORDER_RESULT = 'order_result',
  TRADES_QUEUE = 'trades_q',
  OPEN_ORDER_BOOK = 'open_order_book',
  SOCKET_WALLET_TRANSACTION = 'socket_wallet_transaction',
  STREAM_UPDATE_QUOTE = 'stream_update_quote',
  STREAM_UPDATE_LAST_PRICE = 'stream_update_last_price',
  STREAM_UPDATE_DEPTH = 'stream_update_depth',
  STREAM_UPDATE_LAST_CANDLESTICK = 'stream_update_last_candlestick',
  STREAM_UPDATE_ORDERS = 'stream_update_orders',
  STREAM_UPDATE_TRADES = 'stream_update_trades',
  STREAM_UPDATE_ORDER_BOOK = 'stream_update_order_book',
  CODEX_DEPOSIT = 'codex_deposit',
  CODEX_TRANSFER = 'codex_transfer',
  CODEX_WITHDRAWAL = 'codex_withdrawal',
  CODEX_BALANCES = 'codex_balances',
  CODEX_TRADE = 'codex_trade',
  VAA_LOG = 'vaa_log',
  SETTINGS_UPDATE = 'settings_update',
  POINT_SYSTEM_SETTINGS_UPDATE = 'point_system_settings_update',
  NEW_NOTIFICATION = 'new_notification',
  BALANCE_RESYNC = 'balance_resync',
}

export const QueueOptions: {[key in QueueNames]: { options?: Options.AssertQueue}} = {
  [QueueNames.CANCELLATION_TRADE]: { options: { durable: true }},
  [QueueNames.CANCEL_ORDER]: { options: { durable: true }},
  [QueueNames.CODEX_BALANCES]: { options: { durable: true }},
  [QueueNames.CODEX_DEPOSIT]: { options: { durable: true }},
  [QueueNames.CODEX_TRANSFER]: { options: { durable: true }},
  [QueueNames.CODEX_TRADE]: { options: { durable: true }},
  [QueueNames.CODEX_WITHDRAWAL]: { options: { durable: true }},
  [QueueNames.LAST_LOOK_TRADE]: { options: { durable: true }},
  [QueueNames.MAINTENANCE]: { options: { durable: true }},
  [QueueNames.SYSTEM]: { options: { durable: true }},
  [QueueNames.NEW_ORDER]: { options: { durable: true }},
  [QueueNames.OPEN_ORDER_BOOK]: { options: { durable: true }},
  [QueueNames.ORDER_OPERATION]: { options: { durable: true, maxPriority: 5 }},
  [QueueNames.ORDER_RESULT]: { options: { durable: true }},
  [QueueNames.PROCESS_WALLET_TRANSACTION]: { options: { durable: true }},
  [QueueNames.SEND_TRADE_TO_SETTLE]: { options: { durable: true }},
  [QueueNames.SOCKET_WALLET_TRANSACTION]: { options: { durable: true }},
  [QueueNames.STREAM_UPDATE_DEPTH]: { options: { durable: true }},
  [QueueNames.STREAM_UPDATE_LAST_CANDLESTICK]: { options: { durable: true }},
  [QueueNames.STREAM_UPDATE_LAST_PRICE]: { options: { durable: true }},
  [QueueNames.STREAM_UPDATE_ORDERS]: { options: { durable: true }},
  [QueueNames.STREAM_UPDATE_ORDER_BOOK]: { options: { durable: true }},
  [QueueNames.STREAM_UPDATE_QUOTE]: { options: { durable: true }},
  [QueueNames.STREAM_UPDATE_TRADES]: { options: { durable: true }},
  [QueueNames.TRADES_QUEUE]: { options: { durable: true }},
  [QueueNames.TRADE_CONFIRMED]: { options: { durable: true }},
  [QueueNames.TRADE_FIRE]: { options: { durable: true }},
  [QueueNames.VAA_LOG]: { options: { durable: true }},
  [QueueNames.SETTINGS_UPDATE]: { options: { durable: true }},
  [QueueNames.POINT_SYSTEM_SETTINGS_UPDATE]: { options: { durable: true }},
  [QueueNames.NEW_NOTIFICATION]: { options: { durable: true }},
  [QueueNames.BALANCE_RESYNC]: { options: { durable: true }},
} as const;
